export default "__VITE_ASSET__CJqV1kRl__"